<template>
	<div>
		<a-tabs v-model:activeKey="activeKey" class="ftr-1-25">
			<a-tab-pane key="1" :tab="$t('schedule.teachingTime')">
				<div class="schedule-wid bg-w p-2 mt-4">
					<div class="as-reservation-time">
						<div class="mb15">{{ $t('schedule.availableTeachingTime') }}</div>
						<div class="as-reservation-time-item mb10" v-for="(it,ind) in aotuForm.show_store_data"
							:key="ind">
							<a-checkbox-group v-model:value="it.day_index" @change="setDate">
								<a-checkbox :value="item.value" v-for="(item,index) in weekList"
									style="margin-left: 4px;">{{item.title}}</a-checkbox>
							</a-checkbox-group>
							<div class="flex space mt12" style="padding-right: 41px;">
								<select-time-range :timeInterval="3" :widths="'260'" :timeWidth="110"
									v-model="it.rengeTime" @input="setDate"></select-time-range>
							</div>
							<div class="cl-red as-reservation-time-item-del" @click="delItem(ind)"
								v-if="aotuForm.show_store_data.length!=1">
								{{ $t('common.delete') }}
							</div>
						</div>
						<div class=" mt3 clickAct cl-theme" @click="addList">
							{{ $t('schedule.addTimeSlot') }}
						</div>



						<div class="mt15 mb15">
							{{ $t('schedule.generatedTeachingTime') }}
						</div>
						<a-radio-group v-model:value="selectWeek" button-style="solid" @change="setDate">
							<a-radio-button :value="item.value" class="bg-theme schedule-btn"
								v-for="(item,index) in weekList">{{item.title}}</a-radio-button>
						</a-radio-group>
						<div style="max-height: 140px; overflow-y: scroll;">
							<div class="flex wrap mt10">
								<div class="as-show-list-item" v-for="(item,index) in showTimeList" :key="index">
									{{item}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-4 cl-black ftw600">
					{{ $t('schedule.effectiveDate') }}
				</div>
				<div class="form-check mt-2">
					<input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
						:checked="effective_type_data==1?true:false" @click="effective_type_data=1">
					<label class="form-check-label" for="flexRadioDefault1">
						{{ $t('schedule.always') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
						:checked="effective_type_data==2?true:false" @click="effective_type_data=2">
					<label class="form-check-label" for="flexRadioDefault2">
						{{ $t('schedule.until') }} <a-date-picker v-model:value="deadlineDate"
							valueFormat="YYYY-MM-DD" />
					</label>
				</div>
				<button type="button" class="btn btn-theme mt-3" @click="timeUpdateNew()">
					{{ $t('schedule.save') }}
				</button>
				<div class="bg-w p-2 mt-3 schedule-wid">
					<div class="">
						休息日起設定
					</div>
					<div v-for="(item,index) in restList">
						<div class="flex alcenter mt-3">
							<span class="ftr-1">開始時間：</span>
						
							<a-date-picker v-model:value="item.restDayStart" valueFormat="YYYY-MM-DD" class="mr10" />
							<a-time-picker v-model:value="item.restDayStartTime" format="HH:mm:ss" size="large" valueFormat="HH:mm:ss" />
						
						</div>
						<div class="flex alcenter mt-2">
							<span class="ftr-1">結束時間：</span>
							<a-date-picker v-model:value="item.restDayEnd" valueFormat="YYYY-MM-DD" class="mr10" />
							<a-time-picker v-model:value="item.restDayEndTime" format="HH:mm:ss" size="large" valueFormat="HH:mm:ss" />
							<div class="cl-red as-reservation-time-item-del" @click="delRestItem(index)">
								{{ $t('common.delete') }}
							</div>
						</div>
						<hr />
					</div>
					<div class="mt-3 cl-theme clickAct" @click="addRest">
						添加休息日
					</div>
					<button type="button" class="btn btn-theme mt-3" @click="setRest">
						{{ $t('schedule.save') }}
					</button>
				</div>
				
			</a-tab-pane>
			<a-tab-pane key="2" :tab="$t('studentsCom.calendar')">
				<calendar></calendar>
			</a-tab-pane>
		</a-tabs>


		<!-- <div class="ftr-1-25 ftw600">
            {{ $t('schedule.teachingTime') }}
        </div> -->


	</div>
</template>

<script>
	import moment from "moment"
	import selectTimeRange from "../components/selectTimeRange.vue"
	import calendar from "../components/calendar.vue"
	export default {
		components: {
			selectTimeRange,
			calendar
		},
		data() {
			return {
				aotuForm: {
					private_scheduling_duration: '30', //课程时长
					private_scheduling_interval: '30', //时间间隔
					private_scheduling_num: '', //上课人数
					show_store_data: [],
					store_data: []
				},
				weekList: [{
						value: 1,
						title: '周一'
					},
					{
						value: 2,
						title: '周二'
					},
					{
						value: 3,
						title: '周三'
					},
					{
						value: 4,
						title: '周四'
					},
					{
						value: 5,
						title: '周五'
					},
					{
						value: 6,
						title: '周六'
					},
					{
						value: 7,
						title: '周日'
					}
				],
				showTimeList: [],
				selectWeek: 1,
				weekCountList: [], //用来数据展示计算的数组，以周为基础
				deadlineDate: '',
				teacher_time: [],
				effective_type_data: 1,
				activeKey: '1',
				restList: [{
					restDayStart: '',
					restDayEnd: '',
					restDayStartTime: '',
					restDayEndTime: ''
				}]

			}
		},
		created() {
			this.timeListNew()
			this.getRest()
		},
		methods: {
			convertData2ToData1(data2) {
			    return data2.map(item => {
			        const time_min = `${item.restDayStart} ${item.restDayStartTime}`;
			        const time_max = `${item.restDayEnd} ${item.restDayEndTime}`;
			
			        return {
			            time_min: time_min,
			            time_max: time_max
			        };
			    });
			},
			convertData1ToData2(data1) {
			    return data1.map(item => {
			        const [dateStart, timeStart] = item.time_min.split(' ');
			        const [dateEnd, timeEnd] = item.time_max.split(' ');
			
			        return {
			            restDayStart: dateStart,
			            restDayEnd: dateEnd,
			            restDayStartTime: timeStart,
			            restDayEndTime: timeEnd
			        };
			    });
			},
			setRest(){
				this.$http.api('teacher/teacher/setRest', {
					date: this.convertData2ToData1(this.restList)
				}).then(res => {
					this.$message.success('保存成功')
				})
			},
			getRest(){
				this.$http.api('teacher/teacher/getRest').then(res => {
					this.restList = res.list?this.convertData1ToData2(res.list) :[]
				})
			},
			delRestItem(index){
				this.restList.splice(index,1)
			},
			addRest(){
				this.restList.push({
					restDayStart: '',
					restDayEnd: '',
					restDayStartTime: '',
					restDayEndTime: ''
				})
			},
			// 老师授课时间
			timeUpdateNew() {
				this.teacher_time = []
				this.aotuForm.show_store_data.forEach((item, index) => {
					let obj = {
						monday_switch: item.day_index.includes(1) ? 1 : 0,
						tuesday_switch: item.day_index.includes(2) ? 1 : 0,
						wednesday_switch: item.day_index.includes(3) ? 1 : 0,
						thursday_switch: item.day_index.includes(4) ? 1 : 0,
						friday_switch: item.day_index.includes(5) ? 1 : 0,
						saturday_switch: item.day_index.includes(6) ? 1 : 0,
						sunday_switch: item.day_index.includes(7) ? 1 : 0,
						min_time: item.start_s,
						max_time: item.end_s,
						effective_type_data: this.effective_type_data,
						effective_type_min_time: this.getTodayDate(),
						effective_type_max_time: this.deadlineDate,
					}
					this.teacher_time.push(obj)
				})
				this.$http.api('teacher/teacher/timeUpdateNew', {
					teacher_time: this.teacher_time
				}).then(res => {
					this.$message.success(this.$t('addClass.saveSuccess'), 1, () => {
						this.timeListNew()
						this.$emit('ok')
					})
				})
			},
			// 老师授课时间回显
			timeListNew() {
				this.$http.api('teacher/teacher/timeListNew').then(res => {
					if (res.teacherTime) {
						this.teacher_time = res.teacherTime
						this.aotuForm.show_store_data = []
						this.teacher_time.forEach((item, index) => {
							let arr = []
							item.monday_switch == 1 ? arr.push(1) : ''
							item.tuesday_switch == 1 ? arr.push(2) : ''
							item.wednesday_switch == 1 ? arr.push(3) : ''
							item.thursday_switch == 1 ? arr.push(4) : ''
							item.friday_switch == 1 ? arr.push(5) : ''
							item.saturday_switch == 1 ? arr.push(6) : ''
							item.sunday_switch == 1 ? arr.push(7) : ''
							let obj = {
								day_index: arr,
								end_s: item.max_time,
								start_s: item.min_time,
								rengeTime: [item.min_time, item.max_time]
							}
							this.effective_type_data = Number(item.effective_type_data)
							this.deadlineDate = item.effective_type_max_time
							this.aotuForm.show_store_data.push(obj)
						})
					}
				})
			},
			delItem(index) {
				this.aotuForm.show_store_data.splice(index, 1)
			},
			setDate() {
				this.selectRangeItem()
			},
			monthList() {
				let timeRanges = [],
					arr = []
				this.weekCountList.forEach((item, index) => {
					if (this.selectWeek == item.week) {
						timeRanges = item.timeRanges
					}
				})

				timeRanges.forEach(range => {
					var startTime = moment(range.start, 'HH:mm'); // 将开始时间解析为 moment 对象
					var endTime = moment(range.end, 'HH:mm'); // 将结束时间解析为 moment 对象

					// 循环计算时间节点
					while (startTime < endTime) {
						let str = startTime.format('HH:mm')
						// console.log(startTime.format('HH:mm')); // 输出当前时间节点
						let endStr = endTime.format('HH:mm')

						// 计算时差
						let startDate = new Date('2000-01-01T' + str + ':00');
						let endDate = new Date('2000-01-01T' + endStr + ':00');
						let timeDiff = endDate - startDate;
						let minutesDiff = Math.floor(timeDiff / 60000);
						if (minutesDiff >= this.aotuForm.private_scheduling_duration) {
							arr.push(str)
						}
						if (this.aotuForm.private_scheduling_interval != '' && this.aotuForm
							.private_scheduling_interval != 0) {
							startTime = startTime.add(this.aotuForm.private_scheduling_interval, 'minutes');

						} else if (this.aotuForm.private_scheduling_duration != '' && this.aotuForm
							.private_scheduling_duration != 0) {
							startTime = startTime.add(this.aotuForm.private_scheduling_duration, 'minutes');
						}

					}
					// 排序时间数组
					arr.sort((a, b) => {
						const [aHours, aMinutes] = a.split(':').map(Number);
						const [bHours, bMinutes] = b.split(':').map(Number);
						return aHours === bHours ? aMinutes - bMinutes : aHours - bHours;
					});
				});
				this.showTimeList = arr
			},
			// 每次选完时间段后处理数据格式
			selectRangeItem() {
				if (this.aotuForm.private_scheduling_duration == '') {
					// this.$message.error("请输入时间间隔");
					return
				}
				let arr = [],
					list = []
				this.weekCountList = []
				this.aotuForm.show_store_data.forEach((item, index) => {
					item.start_s = item.rengeTime[0]
					item.end_s = item.rengeTime[1]
					item.day_index.forEach(it => {
						arr.push({
							week: it,
							timeRanges: [{
								start: item.rengeTime[0],
								end: item.rengeTime[1]
							}],
							range: {
								start: item.rengeTime[0],
								end: item.rengeTime[1]
							}
						})
					})
				})
				arr.forEach((item, index) => {
					if (!list.includes(item.week)) {
						list.push(item.week)
						this.weekCountList.push(item)
					} else {
						this.weekCountList.forEach((it, ind) => {
							if (item.week == it.week) {
								it.timeRanges.push(item.range)
							}
						})
					}

				})
				this.monthList()
			},
			// 添加时间段
			addList() {
				console.log("-----",this.aotuForm.show_store_data);
				if(this.aotuForm.show_store_data.length!=0){
					if (this.aotuForm.show_store_data[this.aotuForm.show_store_data.length - 1].day_index == '' || this
						.aotuForm
						.show_store_data[this.aotuForm.show_store_data.length - 1].rengeTime == '') {
						this.$message.error("请选择预约时间");
						return
					}
				}
				
				this.aotuForm.show_store_data.push({
					rengeTime: [],
					start_s: '',
					end_s: '',
					day_index: [1, 2, 3, 4, 5, 6, 7]
				})
			},
		}
	}
</script>

<style scoped>
	::v-deep.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
		background: #3e9699;
		border-color: #3e9699;
	}

	::v-deep .ant-checkbox-checked .ant-checkbox-inner {
		background-color: #52C4C9;
		border-color: #52C4C9;
	}

	::v-deep.form-check-input:checked {
		background-color: #52C4C9;
		border-color: #52C4C9;
	}

	.schedule-wid {
		width: 700px;
	}

	.as-reservation-time {
		background-color: rgb(242, 242, 242);
		padding: 12px;
	}

	.as-reservation-time-item-del {
		position: absolute;
		top: 7px;
		right: 8px;
		cursor: pointer;
	}

	.as-reservation-time-item {
		position: relative;
		background-color: #ffffff;
		border-radius: 4px;
		padding: 8px;
	}

	.as-show-list-item {
		border: 1px solid #ebedf5;
		width: 54px;
		text-align: center;
		margin-bottom: 6px;
		margin-right: 6px;
		padding: 6px 0;
		border-radius: 4px;
		background-color: #fff;
	}

	@media (max-width:575.98px; ) {
		.schedule-wid {
			width: 100%;
		}
	}
</style>